// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"e4b91b84","260":"36c6b2c4","282":"98faf7ac","292":"34a64761","453":"96b22f37","484":"173d25f2","884":"ec40a082"}[chunkId] + ".chunk.js";
};